export const quotingKeys = {
  all: ['quoting'] as const,
  managementIntake: (tenantId: string) =>
    ['quoting', 'management-intake', tenantId] as const,
  owners: (tenantId: string) => ['quoting', 'owners', tenantId] as const,
  intakeSettings: (tenantId: string) =>
    ['quoting', 'intake-settings', tenantId] as const,
  mailboxJobs: (tenantId: string, ids: string[]) =>
    ['quoting', 'mailbox-jobs', tenantId, ...ids] as const,
  requests: (tenantId: string) =>
    [...quotingKeys.all, 'requests', tenantId] as const,
  request: (tenantId: string, id: string) =>
    [...quotingKeys.all, 'request', tenantId, id] as const,
  thread: (tenantId: string, id: string) =>
    [...quotingKeys.all, 'thread', tenantId, id] as const,
  worksheet: (tenantId: string, id: string, asOf: string) =>
    [...quotingKeys.all, 'worksheet', tenantId, id, asOf] as const,
  flow: (tenantId: string, id: string, asOf: string) =>
    [...quotingKeys.all, 'flow', tenantId, id, asOf] as const,
  fields: (tenantId: string) =>
    [...quotingKeys.all, 'fields', tenantId] as const,
  exports: (tenantId: string, id: string) =>
    [...quotingKeys.all, 'exports', tenantId, id] as const,
  ladder: (tenantId: string, id: string, asOf: string) =>
    [...quotingKeys.all, 'ladder', tenantId, id, asOf] as const,
  classEvidence: (tenantId: string, id: string, asOf: string) =>
    [...quotingKeys.all, 'class-evidence', tenantId, id, asOf] as const,
  job: (tenantId: string, jobKey: string) =>
    [...quotingKeys.all, 'job', tenantId, jobKey] as const,
  engineRatings: (tenantId: string, engineKey: string) =>
    [...quotingKeys.all, 'engine-ratings', tenantId, engineKey] as const,
  sound: (tenantId: string, engineKey: string, kw: number, asOf?: string) =>
    [...quotingKeys.all, 'sound', tenantId, engineKey, kw, asOf] as const,
  attachment: (tenantId: string, id: string, name: string) =>
    [...quotingKeys.all, 'attachment', tenantId, id, name] as const,
  exportPdf: (tenantId: string, id: string, name: string) =>
    [...quotingKeys.all, 'export-pdf', tenantId, id, name] as const,
  outlinePrint: (tenantId: string, pn: string) =>
    [...quotingKeys.all, 'outline-print', tenantId, pn] as const,
  outlinePrintPdf: (tenantId: string, file: string) =>
    [...quotingKeys.all, 'outline-print-pdf', tenantId, file] as const,
  /**
   * The runtime gate: whether the tenant quotes, and through which workspace. Its own
   * root, so the desk's broad `quotingKeys.all` invalidations never refetch it (and so it
   * never meets the read-review panel's `['quoting', 'capabilities', …]` health read).
   */
  engineCapabilities: (tenantId: string) =>
    ['quoting-engine-capabilities', tenantId] as const,
  /** The generic engine contract (`/quoting/engine/*`), apart from the AES desk's keys. */
  engine: (tenantId: string) =>
    [...quotingKeys.all, 'engine', tenantId] as const,
  engineQueue: (tenantId: string) =>
    [...quotingKeys.engine(tenantId), 'queue'] as const,
  engineRequest: (tenantId: string, id: string) =>
    [...quotingKeys.engine(tenantId), 'request', id] as const,
  engineFlow: (tenantId: string, id: string, asOf: string) =>
    [...quotingKeys.engine(tenantId), 'flow', id, asOf] as const,
};
